import useConnectWallet from "@/store/wallet/useConnectWallet";
import { useCallback, useEffect, useState } from "react";

/**
 * useCheckLotteryBuff - 检查抽奖结果 Hook
 * 
 * 用于调用 Lottery 合约的 checkLotteryBuff 方法检查是否中奖。
 * 
 * @returns {Object} 返回检查方法、结果和加载状态
 *   - checkLotteryBuff: 执行检查中奖的函数
 *   - isWinner: 是否中奖（boolean）
 *   - checkLotteryBuffLod: 加载状态
 */
const useCheckLotteryBuff2 = () => {
    // 存放数据
    const [isWinner, setIsWinner] = useState<boolean>(false);
    // loading
    const [checkLotteryBuffLod2, setLoading] = useState(false);
    // 获取合约实例和地址
    const { contractEvm: { RegularStaking }, address } = useConnectWallet();

    /**
     * 检查是否中奖
     * @returns 返回是否中奖（boolean）
     */
    const checkLotteryBuff2 = useCallback(async () => {
        setLoading(true);
        if (RegularStaking) {
            try {
                // 调用合约的 checkLotteryBuff 方法
                const result = await RegularStaking.checkLotteryBuff(address);
                // 保存结果
                setIsWinner(result);
                setLoading(false);
                return result;
            } catch (e) {
                console.log("useCheckLotteryBuff2", e);
                setLoading(false);
                return false;
            }
        }
        setLoading(false);
        return false;
    }, [RegularStaking, address]);
    useEffect(() => {
        checkLotteryBuff2()
    }, [checkLotteryBuff2])

    return { checkLotteryBuff2, isWinner, checkLotteryBuffLod2 };
};

export default useCheckLotteryBuff2;
